import React, { useEffect, useState } from 'react';
import { usersDesignationServices } from '../../../APIServices/usersDesignationServices';

function DeleteDesignation({ getUserDesignationData, getDeletedUserDesignationData, setModalOpen, designationData}) {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [designation, setDesignation] = useState("");

  const softDeleteRestoreUserDesignation = async () => {
    setButtonLoader(false);
    let userData = {};
    userData.id = designationData?._id;
    userData.type = "delete";
    let data = await usersDesignationServices.softDeleteRestoreUserDesignation(
      userData
    );
    if (data?.statusCode === 200) {
      getUserDesignationData();
      getDeletedUserDesignationData();
      setModalOpen("");
    }
    setButtonLoader(true);
  }

  return (
    <div
      className="modal-backdrop"
      onClick={() =>
        setModalOpen("")
      }
    >
      <div
        className="modal"
        style={{ maxWidth: 480 }}
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <div className="modal-head">
          <div>
            <div className="modal-title">
              Delete Designation
            </div>

            <div className="xs muted">
              Delete Designation Details
            </div>
          </div>

          <button
            className="icon-btn"
            onClick={() =>
              setModalOpen("")
            }
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-foot">
          <button
            className="btn btn-ghost"
            onClick={() => setModalOpen("")}
          >
            Cancel
          </button>
          <button
            className="btn btn-danger d-flex align-items-center justify-content-center gap-2"
            onClick={() => softDeleteRestoreUserDesignation()}
            disabled={buttonLoader}
          >
            {buttonLoader ? (
              <>
                <div className="buttonLoader"></div>
                <span>Deleting...</span>
              </>
            ) : (
              <>
                <i className="ti ti-check"></i>
                <span>Yes, Delete It!</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteDesignation;